import { useMutation } from "@tanstack/react-query";
import { supabase, invokeFunction } from "@/integrations/supabase/client";
import type { PoolType } from "@/hooks/useProductPools";

export interface AdjustmentCsvLineItem {
  identifier_type: string;
  identifier_value: string;
  quantity: number;
}

interface InvokePayload {
  organisation_id: string;
  source: string;
  effective_date: string;
  filename: string | null;
  line_items: AdjustmentCsvLineItem[];
}

export interface RecordAdjustmentCsvSuccess {
  batch_id: string;
  source: string;
  pool_type?: PoolType;
  transient?: boolean;
  events_written: number;
  affected_products: number;
  skipped_unmapped: number;
  unmapped?: string[];
}

async function invoke(payload: InvokePayload): Promise<RecordAdjustmentCsvSuccess> {
  const { data, error } = await invokeFunction(supabase, "record-adjustment-csv-v1", {
    body: payload,
  });

  if (error) {
    throw new Error(error.message || "Failed to record adjustment upload");
  }
  if (!data?.success) {
    throw new Error(data?.error || "Failed to record adjustment upload");
  }

  return data as RecordAdjustmentCsvSuccess;
}

export function useRecordAdjustmentCsv() {
  const upload = useMutation({
    mutationFn: (payload: InvokePayload) => invoke(payload),
  });

  return { upload };
}
